import IconBox from "../../../../iconboxes/IconBox";
import { majorMedPolicyStatusOptionsPayerTypes } from "../../../../../lib/systemData";

export default function MajorMedDrawerSection({classes, drawerData = {}, goToCaseTabHandler}) {
    const row = drawerData ?? {}
    const majorMeds = Array.isArray(row.major_meds) ? row.major_meds : []
    const primaryMajorMed = majorMeds.find((m) => m.is_primary_insurance) || null
    const majorMedsCount = row.major_meds_count ?? majorMeds.length

    return <div className={classes.block}>
        <div className={classes.block_header}>
            <h3>Major Med</h3>
            {majorMedsCount >= 2 && <div className={classes.totals}>{majorMedsCount}</div>}
            <button onClick={goToCaseTabHandler.bind(this, 5)}><i className='ti ti ti-arrow-up-right'></i></button>
        </div>
        <div className={classes.block_body}>
            <div className={classes.block_body_row}>
                <div className={classes.label}>Carrier</div>
                <div className={classes.value}>{primaryMajorMed?.insurance_carrier?.name}</div>
            </div>
            <div className={classes.block_body_row}>
                <div className={classes.label}>Status</div>
                <div className={classes.value}>
                    {majorMedPolicyStatusOptionsPayerTypes()?.find(item => item.value == primaryMajorMed?.policy_status)?.label}
                </div>
            </div>
            <div className={classes.block_body_row}>
                <div className={classes.label}>Adjuster</div>
                <div className={classes.value}>
                    {primaryMajorMed?.adjuster && <>
                        <div>{primaryMajorMed.adjuster.first_name} {primaryMajorMed.adjuster.last_name}</div>
                        {/* <div><i className='ti ti-phone'></i></div> */}
                        {primaryMajorMed.adjuster.contact_information && primaryMajorMed.adjuster.contact_information.phone && <IconBox type={'phone'} link={primaryMajorMed.adjuster.contact_information.phone} workq={true}>
                            <i className="ti ti-phone"></i>
                        </IconBox>}
                    </>}
                </div>
            </div>
            <div className={classes.block_body_row} >
                <div className={classes.label}>Policy Number</div>
                <div className={classes.value}>{primaryMajorMed?.policy_number}</div>
            </div>
            
        </div>
    </div>
}